import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Route } from 'react-router-dom';

const RouteWithSubRoutes = props => {
  const { path, exact, childRoutes, RouteComponent, ...rest } = props;

  return (
    <Route
      path={path}
      exact={exact}
      render={props => (
        <RouteComponent
          childRoutes={childRoutes}
          {...rest}
        />
      )}
    />
  );
};

RouteWithSubRoutes.propTypes = {
  path: PropTypes.string.isRequired,
  backPath: PropTypes.string,
  exact: PropTypes.bool,
  childRoutes: PropTypes.array,
  RouteComponent: PropTypes.oneOfType([PropTypes.element, PropTypes.func])
    .isRequired,
};

export default withRouter(RouteWithSubRoutes);



// WEBPACK FOOTER //
// ./src/utils/router/RouteWithSubRoutes.js